// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__3MM8v"};